import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductResolver } from '../../../../../resolvers/product.resolver';
import { FlexReportComponent } from './flex-report.component';

const routes: Routes = [
    {
        path: '',
        component: FlexReportComponent,
        resolve: {
            product: ProductResolver,
        }
    }
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FlexReportsRoutingModule {}